<template>
  <main
    class="
      relative
      z-50
      grid grid-cols-2
      w-double
      lg:w-screen
      h-full
      transition
      duration-500
      transform
      bg-white bg-opacity-90
      overflow-hidden
    "
    :class="{
      'opacity-0 pointer-events-none': hidden,
      'opacity-100 pointer-events-auto': !hidden,
      '-translate-x-1/2 lg:translate-x-0 pb-10 lg:pb-0': !menu,
      'pb-0': menu,
    }"
  >
    <navigation :view="view" @open="updateHistory" />
    <viewer ref="view" :view="view" />
  </main>
</template>

<script>
const Navigation = () =>
  import(/* webpackChunkName: "Navigation" */ "@/components/Navigation.vue");
const Viewer = () =>
  import(/* webpackChunkName: "Viewer" */ "@/components/Viewer.vue");
import { mapState } from "vuex";
export default {
  name: "home",
  metaInfo() {
    return {
      title: this.site.title,
      titleTemplate: null,
    };
  },
  data() {
    return {
      hidden: true,
      menu: true,
      view: "info",
    };
  },
  components: {
    Navigation,
    Viewer,
  },
  computed: mapState(["site"]),
  mounted() {
    this.$root.$on("goHome", () => {
      this.menu = true;
      this.$refs.view.scrollToTop();
    });
    this.$root.$on("openMenu", () => {
      this.hidden = false;
      if(window.innerWidth > 768) {
        this.changeView('info');
      }
    });
    this.$root.$on("closeMenu", () => {
      this.hidden = true;
      
    });
    this.$root.$on('goToPage', this.changeView);
  },
  methods: {
    changeView(payload) {
      this.$root.$emit("openPage");
      this.menu = false;
      this.view = payload;
    },
    updateHistory(payload) {
      this.$root.$emit("openPage");
      this.menu = false;
      this.view = payload;
      history.pushState(null, "", window.location.pathname + '#' + payload);
    }
  },
};
</script>
